import React from 'react';
import {Row,Col,Select,Input,Button,Typography} from 'antd'
import { Colors } from "theme";


const {Option}=Select
const {Text} =Typography;
export default function BulkEditModal(
    {
        showBulkEdit,
        setShowBulkEdit,
        tabName,
        bulkEditOperation,
        handleChangeOperation,
        bulkEditcolumn,
        handleChangeColumn,
        bulkEditValue,
        handlebulkEditValue,
        executeBulkEdit
    }
) {
      //prefix component
  const prefixSelector = <span>by</span>;
  // surfix component
  const suffixSelector = (
    <span>%</span>
    // <Select
    //   defaultValue={bulkEditBy}
    //   style={{ width: 100 }}
    //   onChange={handleChangeEditBy}
    // >
    //   <Option value="percent">%</Option>
    //   {/* <Option value="value">value</Option> */}
    // </Select>
  );
    return (
        <div hidden={showBulkEdit}>
          <Row justify="end" style={{ width: "100%" }}>
            <Col className="bulk-edit-card" >
              <Row style={{ marginBottom: "1.2rem" }}>
                <Col>
                  <Text>
                    Edit details of all the products in 
                    <Text style={{ fontSize: "1rem" }}> {tabName} </Text> at once{" "}
                  </Text>
                </Col>
              </Row>

              <Row justify="space-between">
                <Col>
                  <Select
                    value={bulkEditOperation}
                    style={{ width: 100}}
                    onChange={handleChangeOperation}
                  >
                    <Option value="increase">Increase</Option>
                    <Option value="decrease">Decrease</Option>
                  </Select>
                </Col>
                <Col>
                  <Select
                    defaultValue={bulkEditcolumn}
                    style={{ width: 100}}
                    onChange={handleChangeColumn}
                  >
                    <Option value="price">Price</Option>
                    <Option value="moq">MOQ</Option>
                  </Select>
                </Col>
                <Col>
                  <Input
                    value={bulkEditValue}
                    type="number"
                    addonBefore={prefixSelector}
                    addonAfter={suffixSelector}
                    onChange={handlebulkEditValue}
                  />
                </Col>
                <Col>
                  <Button
                    style={{ background: Colors.black, color: Colors.white }}
                    onClick={()=>setShowBulkEdit(state=>!state)}
                  >
                    Done
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

    )
}
